// Sorting Model Action Types
export const CREATE_SORTING_MODEL_REQUEST = 'CREATE_SORTING_MODEL_REQUEST';
export const CREATE_SORTING_MODEL_SUCCESS = 'CREATE_SORTING_MODEL_SUCCESS';
export const CREATE_SORTING_MODEL_FAILURE = 'CREATE_SORTING_MODEL_FAILURE';

export const FETCH_SORTING_RESULTS_REQUEST = 'FETCH_SORTING_RESULTS_REQUEST';
export const FETCH_SORTING_RESULTS_SUCCESS = 'FETCH_SORTING_RESULTS_SUCCESS';
export const FETCH_SORTING_RESULTS_FAILURE = 'FETCH_SORTING_RESULTS_FAILURE';

export const LOAD_MORE_SORTING_RESULTS_REQUEST = 'LOAD_MORE_SORTING_RESULTS_REQUEST';
export const LOAD_MORE_SORTING_RESULTS_SUCCESS = 'LOAD_MORE_SORTING_RESULTS_SUCCESS';
export const LOAD_MORE_SORTING_RESULTS_FAILURE = 'LOAD_MORE_SORTING_RESULTS_FAILURE';

export const SET_SORTING_MODEL_WEIGHTAGES = 'SET_SORTING_MODEL_WEIGHTAGES';
export const RESET_SORTING_MODEL = 'RESET_SORTING_MODEL';
export const SET_SORTING_MODEL_VISIBILITY = 'SET_SORTING_MODEL_VISIBILITY';
